// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ViewClanBattles_wrapper_1uPSF","tabsNavigation":"ViewClanBattles_tabsNavigation_39-mv"};